import * as types from '../actions/actionTypes';

const initialState = {
  wizardOpened: false,
  wizardName: "",
  wizardStep: -1,
};

export default function(state = initialState, action){
  switch (action.type) {
    case types.SET_GROHE_WIZARD_NAME:
    case types.SET_GROHE_WIZARD_OPENED:
    case types.SET_GROHE_WIZARD_STEP:
      return Object.assign({}, state, {
        ...action.payload
      });
  }
  return state;
}
